<template>
    <div class="sf-filters">
        <details
            v-if="isMobile"
            class="sf-filters--mobile"
            :open="isFilterOpen"
        >
            <summary
                id="filters-mobile-button"
                aria-controls="filters-mobile-content"
                :aria-expanded="isFilterOpen"
                class="sf-filters__button"
                role="button"
                @click.prevent="toggleFilter"
            >
                <span>filter <span class="sr-only">resultaten</span></span>

                <sf-icon
                    class="sf-filters__icon"
                    icon="chevron-down"
                />
            </summary>

            <div
                id="filters-mobile-content"
                aria-labelledby="filters-mobile-button"
                class="sf-filters__body"
            >
                <slot />
            </div>
        </details>

        <div
            v-else
            class="sf-filters__body sf-filters--desktop"
        >
            <slot />
        </div>

        <div class="sf-filters__refinements">
            <ais-current-refinements />
        </div>
    </div>
</template>

<script>
import { AisCurrentRefinements } from 'vue-instantsearch/vue3/es/index.js';
import SfIcon from '~/patterns/atoms/icon/icon.vue';

export default {
    components: {
        AisCurrentRefinements,
        SfIcon
    },

    data() {
        return {
            isFilterOpen: false,
            isMobile: false,
        };
    },

    mounted() {
        this.handleResize();
    },

    unmounted() {
        window.removeEventListener('resize', this.setIsMobile);
    },

    methods: {
        toggleFilter() {
            this.isFilterOpen = !this.isFilterOpen;
        },
        setIsMobile() {
            this.isMobile = window.innerWidth <= 576;
        },
        handleResize() {
            this.setIsMobile();
            window.addEventListener('resize', this.setIsMobile);
        }
    }
};
</script>

<style lang="less" src="./filters.less"></style>
